////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const articleLifeManager = {
	resetDataArticleLife: () => ({
		type: ActionsTypes.RESET_DATA_ARTICLE_LIFE,
	}),

	getTimeline: (id, year) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE,
		payload: { id, year },
	}),
	getTimelineSuccess: (data) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_SUCCESS,
		payload: {
			data,
		},
	}),
	getTimelineFailure: (error) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_FAILURE,
		payload: {
			error,
		},
	}),

	getTimelinePhases: (id) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES,
		payload: { id },
	}),
	getTimelinePhasesSuccess: (data) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES_SUCCESS,
		payload: {
			data,
		},
	}),
	getTimelinePhasesFailure: (error) => ({
		type: ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES_FAILURE,
		payload: {
			error,
		},
	}),

	/**
	 *
	 * @param {String} id
	 * @return {{payload: {id}, type: string}}
	 */
	getHeaderAndAction: (id) => ({
		type: ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE,
		payload: {
			id,
		},
	}),

	/**
	 *
	 * @param {Object} data
	 * @return {{payload, type: string}}
	 */
	getHeaderAndActionSuccess: (data) => ({
		type: ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE_SUCCESS,
		payload: {
			...data,
		},
	}),

	/**
	 *
	 * @param error
	 * @return {{payload: {error}, type: string}}
	 */
	getHeaderAndActionFailure: (error) => ({
		type: ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE_FAILURE,
		payload: {
			...error,
		},
	}),

	postDeletedItem: (id, query, date) => ({
		type: ActionsTypes.POST_DELETED_ITEM,
		payload: {
			id,
			query,
			date,
		},
	}),

	postDeletedItemSuccess: () => ({
		type: ActionsTypes.POST_DELETED_ITEM_SUCCESS,
		payload: {},
	}),
	postDeletedItemFailure: (error) => ({
		type: ActionsTypes.POST_DELETED_ITEM_FAILURE,
		payload: {
			error,
		},
	}),
	postUnactiveItem: (id, query) => ({
		type: ActionsTypes.POST_UNACTIVE_ITEM,
		payload: {
			id,
			query,
		},
	}),

	postUnactiveItemSuccess: () => ({
		type: ActionsTypes.POST_UNACTIVE_ITEM_SUCCESS,
		payload: {},
	}),
	postUnactiveItemFailure: (error) => ({
		type: ActionsTypes.POST_UNACTIVE_ITEM_FAILURE,
		payload: {
			error,
		},
	}),

	postDeleteStopDeposit: (id, query) => ({
		type: ActionsTypes.POST_DELETE_STOP_DEPOSIT,
		payload: {
			id,
			query,
		},
	}),

	postDeleteStopDepositSuccess: () => ({
		type: ActionsTypes.POST_DELETE_STOP_DEPOSIT_SUCCESS,
		payload: {},
	}),
	postDeleteStopDepositFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_STOP_DEPOSIT_FAILURE,
		payload: {
			error,
		},
	}),

	postActiveItem: (id, query) => ({
		type: ActionsTypes.POST_ACTIVED_ITEM,
		payload: {
			id,
			query,
		},
	}),

	postActiveItemSuccess: () => ({
		type: ActionsTypes.POST_ACTIVED_ITEM_SUCCESS,
		payload: {},
	}),
	postActiveItemFailure: (error) => ({
		type: ActionsTypes.POST_ACTIVED_ITEM_FAILURE,
		payload: {
			error,
		},
	}),

	updateStartDepositAction: (id, date) => ({
		type: ActionsTypes.UPDATE_START_DEPOSIT_ACTION,
		payload: {
			id,
			date,
		},
	}),

	updateStartDepositActionSuccess: () => ({
		type: ActionsTypes.UPDATE_START_DEPOSIT_ACTION_SUCCESS,
		payload: {},
	}),
	updateStartDepositActionFailure: (error) => ({
		type: ActionsTypes.UPDATE_START_DEPOSIT_ACTION_FAILURE,
		payload: {
			error,
		},
	}),

	updateStopDepositAction: (id, date) => ({
		type: ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION,
		payload: {
			id,
			date,
		},
	}),

	updateStopDepositActionSuccess: () => ({
		type: ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION_SUCCESS,
		payload: {},
	}),
	updateStopDepositActionFailure: (error) => ({
		type: ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION_FAILURE,
		payload: {
			error,
		},
	}),
	postAddStopDeposit: (id, query, date) => ({
		type: ActionsTypes.POST_ADD_STOP_DEPOSIT,
		payload: {
			id,
			query,
			date,
		},
	}),

	postAddStopDepositSuccess: () => ({
		type: ActionsTypes.POST_ADD_STOP_DEPOSIT_SUCCESS,
		payload: {},
	}),
	postAddStopDepositFailure: (error) => ({
		type: ActionsTypes.POST_ADD_STOP_DEPOSIT_FAILURE,
		payload: {
			error,
		},
	}),
	postDeleteAddStartWithDeposit: (id) => ({
		type: ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT,
		payload: {
			id,
		},
	}),

	postDeleteAddStartWithDepositSuccess: () => ({
		type: ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT_SUCCESS,
		payload: {},
	}),
	postDeleteAddStartWithDepositFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT_FAILURE,
		payload: {
			error,
		},
	}),
	postDeleteScheduledActivate: (id) => ({
		type: ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE,
		payload: {
			id,
		},
	}),

	postDeleteScheduledActivateSuccess: () => ({
		type: ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE_SUCCESS,
		payload: {},
	}),
	postDeleteScheduledActivateFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE_FAILURE,
		payload: {
			error,
		},
	}),

	postAddStartWithDeposit: (id, query, date) => ({
		type: ActionsTypes.POST_ADD_START_WITH_DEPOSIT,
		payload: {
			id,
			query,
			date,
		},
	}),

	postAddStartWithDepositSuccess: () => ({
		type: ActionsTypes.POST_ADD_START_WITH_DEPOSIT_SUCCESS,
		payload: {},
	}),
	postAddStartWithDepositFailure: (error) => ({
		type: ActionsTypes.POST_ADD_START_WITH_DEPOSIT_FAILURE,
		payload: {
			error,
		},
	}),

	postScheduleActivateAction: (id, query, date) => ({
		type: ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION,
		payload: {
			id,
			query,
			date,
		},
	}),

	postScheduleActivateActionSuccess: () => ({
		type: ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION_SUCCESS,
		payload: {},
	}),
	postScheduleActivateActionFailure: (error) => ({
		type: ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION_FAILURE,
		payload: {
			error,
		},
	}),
	updateScheduledActivateAction: (id, query, date) => ({
		type: ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION,
		payload: {
			id,
			query,
			date,
		},
	}),
	updateScheduledActivateActionSuccess: () => ({
		type: ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION_SUCCESS,
		payload: {},
	}),
	updateScheduledActivateActionFailure: (error) => ({
		type: ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION_FAILURE,
		payload: {
			error,
		},
	}),
	postScheduledDeactivateAction: (id, query, body, isScheduled) => ({
		type: ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION,
		payload: {
			id,
			query,
			body,
			isScheduled,
		},
	}),
	postScheduledDeactivateActionSuccess: () => ({
		type: ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION_SUCCESS,
		payload: {},
	}),
	postScheduledDeactivateActionFailure: (error) => ({
		type: ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION_FAILURE,
		payload: {
			error,
		},
	}),
	postCancelDeactivateAction: (id, query) => ({
		type: ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION,
		payload: {
			id,
			query,
		},
	}),

	postCancelDeactivateActionSuccess: () => ({
		type: ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION_SUCCESS,
		payload: {},
	}),
	postCancelDeactivateActionFailure: (error) => ({
		type: ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION_FAILURE,
		payload: {
			error,
		},
	}),

	postDeleteDesactivationScheduled: (id, date) => ({
		type: ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED,
		payload: {
			id,
			date,
		},
	}),

	postDeleteDesactivationScheduledSuccess: () => ({
		type: ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED_SUCCESS,
		payload: {},
	}),
	postDeleteDesactivationScheduledFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED_FAILURE,
		payload: {
			error,
		},
	}),
	postDeleteStopWithRestockAction: (id, date) => ({
		type: ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK,
		payload: {
			id,
			date,
		},
	}),

	postDeleteStopWithRestockActionSuccess: () => ({
		type: ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK_SUCCESS,
		payload: {},
	}),
	postDeleteStopWithRestockActionFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK_FAILURE,
		payload: {
			error,
		},
	}),
	postAddStopWithRestock: (id, query, date) => ({
		type: ActionsTypes.POST_ADD_STOP_WITH_RESTOCK,
		payload: {
			id,
			query,
			date,
		},
	}),
	postAddStopWithRestockSuccess: () => ({
		type: ActionsTypes.POST_ADD_STOP_WITH_RESTOCK_SUCCESS,
		payload: {},
	}),
	postAddStopWithRestockFailure: (error) => ({
		type: ActionsTypes.POST_ADD_STOP_WITH_RESTOCK_FAILURE,
		payload: {
			error,
		},
	}),
	postEditStopWithRestock: (id, query, date) => ({
		type: ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK,
		payload: {
			id,
			query,
			date,
		},
	}),
	postEditStopWithRestockSuccess: () => ({
		type: ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK_SUCCESS,
		payload: {},
	}),
	postEditStopWithRestockFailure: (error) => ({
		type: ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK_FAILURE,
		payload: {
			error,
		},
	}),
}

export default articleLifeManager
